// Where Work opens (Work UX pass 2026-10-20 "one click to the work"): the board you opened last,
// else My tasks. The boards you open are kept per company in this browser (`localStorage`), the
// last one first; Work home lists them as Recent. Pure apart from the storage adapter.

export type Storage = Pick<globalThis.Storage, "getItem" | "setItem">;

const RECENT_MAX = 8;

export const recentKey = (slug: string) => `companyos.work.recent.${slug}`;

function store(): Storage | null {
  try {
    return typeof window === "undefined" ? null : window.localStorage;
  } catch {
    return null;
  }
}

/** Board ids opened in this company, newest first. */
export function readRecentBoards(slug: string, storage: Storage | null = store()): string[] {
  try {
    const raw = storage?.getItem(recentKey(slug));
    const list: unknown = raw ? JSON.parse(raw) : [];
    return Array.isArray(list) ? list.filter((x): x is string => typeof x === "string") : [];
  } catch {
    return [];
  }
}

/** Moves (or adds) a board to the front of the recent list; at most eight are kept. */
export function rememberBoard(slug: string, boardId: string, storage: Storage | null = store()) {
  const next = [boardId, ...readRecentBoards(slug, storage).filter((id) => id !== boardId)].slice(
    0,
    RECENT_MAX,
  );
  try {
    storage?.setItem(recentKey(slug), JSON.stringify(next));
  } catch {
    // storage blocked: the landing holds for this page only
  }
  return next;
}

/** A board that no longer exists (archived, or another company's) must not be the landing. */
export function forgetBoard(slug: string, boardId: string, storage: Storage | null = store()) {
  const next = readRecentBoards(slug, storage).filter((id) => id !== boardId);
  try {
    storage?.setItem(recentKey(slug), JSON.stringify(next));
  } catch {
    // as above
  }
  return next;
}

/** `/work` lands on the last board, else on My tasks. */
export function workLanding(
  slug: string,
  storage: Storage | null = store(),
): { to: "/c/$slug/work/b/$boardId"; boardId: string } | { to: "/c/$slug/work/my" } {
  const [last] = readRecentBoards(slug, storage);
  return last ? { to: "/c/$slug/work/b/$boardId", boardId: last } : { to: "/c/$slug/work/my" };
}
